//import logo from "./logo.svg";
import "./App.css";
import PageLayout from "./components/PageLayout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RegistrationResponsePage from "./components/Response";
import ErrorPage from "./components/ErrorPage";

function App() {
  return (
    <Router>
      <div className="Appx">
        <Routes>
          <Route path="/" element={<PageLayout />} />
          <Route path="/response" element={<RegistrationResponsePage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </div>
    </Router>
  );
}
//https://yellow-plant-0f7c60610.1.azurestaticapps.net

export default App;
